import { useParams, useHistory } from 'react-router-dom';
import { getAppRoutes } from 'Pages/App/App.constants';

import { useCreateRole, useRoleDetail } from '../Roles.hooks';
import PermissionList, { RoleSubmitPayload } from './PermissionList';
import Spin from 'Components/Spin/Spin';

function CloneRole() {
	const { roleId } = useParams<{ roleId: string }>();
	const history = useHistory();
	const { role, permissionList, loading } = useRoleDetail(roleId);
	const [createRole, { loading: cloning }] = useCreateRole();

	const handleSubmit = async (values: RoleSubmitPayload) => {
		await createRole(values); // roleName/description here are the NEW clone's values,
		history.push(getAppRoutes().ROLES); // pre-filled from the source role but editable
	};

	if (loading || !role) return <Spin />; 

	return (
		<PermissionList
			mode="clone"
			permissionList={permissionList}
			initialValues={{
				roleName: `${role.role} clone`,
				description: role.description,
				sourceRoleName: role.role
			}}
			loading={cloning}
			onCancel={() => history.goBack()}
			onSubmit={handleSubmit}
		/>
	);
}

export default CloneRole;